import PropTypes from 'prop-types';
import { useContext } from 'react';
import {
  APPLE_EXTERNAL_SUBSCRIPTION_STATUS,
  GOOGLE_EXTERNAL_SUBSCRIPTION_STATUS,
  OTHER_EXTERNAL_SUBSCRIPTION_STATUS,
  RENEW_SUBSCRIPTION_BUTTON,
} from 'src/common/constants/localizations/subscription';
import { providers } from 'src/common/utils/subscription/getSubscriptionProvider';
import { premiumSubscriptionStatus } from 'src/common/utils/subscription/subscriptionStatus';
import { LocationAndLocalizationContext } from '../../../providers/LocationAndLocalizationProvider';
import PillButtonLink from '../../shared/button/PillButtonLink';
import css from './subscription.module.scss';

const subscriptionStatusMap = {
  [providers.apple]: APPLE_EXTERNAL_SUBSCRIPTION_STATUS,
  [providers.google]: GOOGLE_EXTERNAL_SUBSCRIPTION_STATUS,
  [providers.other]: OTHER_EXTERNAL_SUBSCRIPTION_STATUS,
};

const ExternalSubscription = ({ providerName, subscriptionStatus }) => {
  const { getLocalizedText } = useContext(LocationAndLocalizationContext);

  return (
    <div className="row">
      <div className="col-xs-12 col-sm-6">
        {subscriptionStatus === premiumSubscriptionStatus.expired ? (
          <PillButtonLink
            id="renewSubscriptionButton"
            dataTestId="renewSubscriptionButton"
            label={getLocalizedText(RENEW_SUBSCRIPTION_BUTTON)}
            to="/renew"
          />
        ) : (
          <div data-testid="externalPaymentDetails" className={css.paymentDetails}>
            {getLocalizedText(subscriptionStatusMap[providerName])}
          </div>
        )}
      </div>
    </div>
  );
};

ExternalSubscription.propTypes = {
  providerName: PropTypes.oneOf([providers.apple, providers.google, providers.other]).isRequired,
  subscriptionStatus: PropTypes.string.isRequired,
};

export default ExternalSubscription;
